import React from 'react'

import { Button, Flex, TextBox, Box, DesktopBlock, MobileBlock } from 'landing/kit'
import { Container, H2 } from '../styles'
import {Card} from './styles'

import clock from './assets/clock.svg';
import cup from './assets/cup.svg';
import heart from './assets/heart.svg';
import { logEvent } from 'landing/services/analytics'
import styled from "styled-components";


const DemoBlock = () => {

  const handleBookADemo = React.useCallback(() => {
    window.Calendly.initPopupWidget({url: 'https://calendly.com/pitchme-demo/30min'})
    logEvent('gtm-employer-event', 'employer', 'book-a-demo', 'click')
  }, [])

  return (
    <Container mx={20} css={{zIndex: 1}}>
      <Card justifyContent="space-between" flexDirection={{_: 'column', lg: 'row'}}>
        <Flex flexDirection="column" mr={{_: 0, lg: '20px'}}>
          <H2 color="white" lineHeight={1.2} textAlign={{_: 'center', lg: 'left'}} mb="32px">
            Do you want<br/>to know more?
          </H2>
          <DesktopBlock>
            <DesktopButton
              as="a"
              onClick={() => handleBookADemo()}
              variant="secondary"
              size="large"
            >
              Book a demo
            </DesktopButton>
          </DesktopBlock>
        </Flex>
        <Flex flexDirection="column">
          <Flex mb={36}>
            <Box as="img" src={clock} mr={{_: '16px', lg: '55px'}} width={{_: '52px', lg: 'auto'}}/>
            <FlexMax flexDirection="column" justifyContent="center">
              <TextBox fontSize={24} lineHeight={1.3} color="white" fontWeight={700}>
                Pick a time
              </TextBox>
              <TextBox fontSize={16} lineHeight={1.3} color="white" fontWeight={400}>
                Simply book a slot that suits you.
              </TextBox>
            </FlexMax>
          </Flex>
          <Flex mb={36}>
            <Box as="img" src={cup} mr={{_: '16px', lg: '55px'}} width={{_: '52px', lg: 'auto'}}/>
            <Flex flexDirection="column" justifyContent="center" css={{maxWidth: '336px'}}>
              <TextBox fontSize={24} lineHeight={1.3} color="white" fontWeight={700}>
                See PitchMe in action
              </TextBox>
              <TextBox fontSize={16} lineHeight={1.3} color="white" fontWeight={400}>
                Understand how PitchMe's integrations work through a live use case.
              </TextBox>
            </Flex>
          </Flex>
          <Flex>
            <Box as="img" src={heart} mr={{_: '16px', lg: '55px'}} width={{_: '52px', lg: 'auto'}}/>
            <FlexMax flexDirection="column" justifyContent="center">
              <TextBox fontSize={24} lineHeight={1.3} color="white" fontWeight={700}>
                Have all the facts
              </TextBox>
              <TextBox fontSize={16} lineHeight={1.3} color="white" fontWeight={400}>
                Discover if the tool is what your team needs.
              </TextBox>
            </FlexMax>
          </Flex>
        </Flex>
        <MobileBlock>
          <MobileButton
            onClick={() => handleBookADemo()}
            as="a"
            variant="secondary"
            size="large"
          >
            Book a demo
          </MobileButton>
        </MobileBlock>
      </Card>
    </Container>
  )
}

export default DemoBlock


export const DesktopButton = styled(Button)`
  background: white;
  color: #9255FA;
  &:hover { 
    background: white; 
    color: #9255FA 
  }
  border: 1px solid #9255FA;
  max-width: 367px;
  box-shadow: 0 12px 40px -16px rgba(24, 65, 148, 0.6);
  padding-left: 0;
  padding-right: 0;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
`

export const MobileButton = styled(Button)`
  background: white;
  color: #9255FA;
  &:hover { 
    background: white; 
    color: #9255FA 
  }
  border: 1px solid #9255FA;
  box-shadow: 0 12px 40px -16px rgba(24, 65, 148, 0.6);
  padding-left: 0;
  padding-right: 0;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  margin-top: 50px;
`

export const FlexMax = styled(Flex)`
  max-width: 336px;
`
